module.exports = __webpack_public_path__ + "img/925-c8ed3d.png";